export const mapAmountPageModelToRequest = (amount: string): number => {
  return amount && parseInt(amount.replace(" ", ""), 10);
};

export const mapAmountDocumentToPageModel = (amount: number): string =>
  amount && `${amount}`;
